<div class="auth-account-balance">
    <shared-header type="5" [center]="true" class="auth-account-balance__hd"
        [loading]="(accountBalance$ | async)?.isDownloading === true" marginBottom="xs">
        <ng-container *ngIf="hideAmount$ | async">Account Purchases</ng-container>
        <ng-container *ngIf="(hideAmount$ | async) === false">Account Balance</ng-container>
    </shared-header>
    <shared-header type="2" [center]="true" [brandAccent]="true" marginTop="none"
        [loading]="(accountBalance$ | async)?.isDownloading === true" class="auth-account-balance__value">
        <shared-auth-balance-value [value]="(accountBalance$ | async)?.data?.AvailableBalance">
        </shared-auth-balance-value>
    </shared-header>
</div>